import * as React from 'react'
import Button from 'components/Button'

import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'

interface IPrevNextButtonsProps {
  next?: string
  back?: string
  onBack: Function
  loading?: boolean
  disabled?: boolean
}

export const PrevNextButtons = ({
  next = 'Next',
  back = 'Back',
  onBack,
  loading,
  disabled,
}: IPrevNextButtonsProps) => {
  return (
    <div
      className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}
      style={{ marginTop: '40px' }}
    >
      {next && (
        <Button color="tertiary" type="submit" loading={loading} disabled={disabled}>
          {next}
        </Button>
      )}
      <br />
      <br />
      {back && (
        <Button plain onClick={onBack}>
          {back}
        </Button>
      )}
    </div>
  )
}



// WEBPACK FOOTER //
// src/features/MobileServices/MobileServiceForm/PrevNextButtons/PrevNextButtons.tsx